<template>
  <div class="position-relative">
    <!-- <HeraFormBtn
      fill="white"
      :label="$t('_web_battles_round-chat', 'Group Chat')"
      class="btn-secondary-simple d-flex align-items-center"
      :class="{ 'is-loading': isLoading }"
      :disabled="isLoading"
      @click="togglePopover"
    /> -->
    <button
      fill="white"
      :label="$t('_web_battles_round-chat', 'Group Chat')"
      class="group-chat-round"
      :class="{ 'is-loading': isLoading }"
      :disabled="isLoading"
      @click="togglePopover"
    >
      <div class="btn-inside-wrap">
        {{ $t('_web_battles_round-chat', 'Group Chat') }}
        <HeraIcon
          name="dropdown"
          :rotate="popoverPosition ? 180 : 0"
          :width="14"
        />
      </div>
    </button>

    <Popover
      class="popover"
      :position="popoverPosition"
      :float="['right']"
      :items="items"
      :closest="$el"
      auto-close
      @toggle="popoverToggleHandler"
    >
      <span slot-scope="{ item }" @click="openChat(item.signature)">
        {{ item.label }}
      </span>
    </Popover>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import isLoading from '@/mixins/isLoading';
// import HeraFormBtn from '@/components/atoms/HeraFormBtn';
import Popover from '@/components/popover/Menu';
import { prop } from '@/utils/factories';
import HeraIcon from '@/components/atoms/Icon';

export default {
  name: 'RoundChatButton',
  components: {
    HeraIcon,
    // HeraFormBtn,
    Popover,
  },
  mixins: [isLoading],
  props: {
    blockId: {
      type: [String, Number],
      required: true,
    },
    round: {
      type: [Number, String],
      required: true,
    },
    roundName: {
      type: String,
      default: '',
    },
    grid: prop(String, null),
    closest: {
      type: Node,
      default: null,
    },
  },
  data() {
    return {
      popoverPosition: null,
    };
  },
  computed: {
    ...mapGetters(['currentTournament']),
    items() {
      return [
        {
          label: this.$t(
            '_web_battles_chat-winners',
            'Chat with winners (captains)'
          ),
          signature: { conversationType: 'group_chat', targetGroup: 'Winners' },
        },
        {
          label: this.$t(
            '_web_battles_chat-loosers',
            'Chat with eliminated (captains)'
          ),
          signature: { conversationType: 'group_chat', targetGroup: 'Losers' },
        },
        {
          label: this.$t('_web_battles_chat-all', 'Chat with all'),
          signature: { conversationType: 'group_chat', targetGroup: 'All' },
        },
        {
          label: this.$t(
            '_web_battles_channel-winners',
            'Channel with winners (captains)'
          ),
          signature: { conversationType: 'channel', targetGroup: 'Winners' },
        },
        {
          label: this.$t(
            '_web_battles_channel-loosers',
            'Channel with eliminated (captains)'
          ),
          signature: { conversationType: 'channel', targetGroup: 'Losers' },
        },
        {
          label: this.$t('_web_battles_channel-all', 'Channel with all'),
          signature: { conversationType: 'channel', targetGroup: 'All' },
        },
      ];
    },
  },
  methods: {
    ...mapActions(['createTournamentConversationBySignature', 'errorNotify']),
    ...mapMutations([
      'openConversationInSliderChatEditor',
      'toggleSliderChat',
      'sliderChatToggleLoader',
      'currentTournamentBlock',
    ]),
    togglePopover(event) {
      this.popoverPosition = this.popoverPosition
        ? null
        : event.target.closest('button');
    },
    popoverToggleHandler(isVisible) {
      if (!isVisible) {
        this.popoverPosition = null;
      }
    },
    openChat(signature) {
      this.setLoading();
      this.toggleSliderChat();
      this.sliderChatToggleLoader(true);
      const { conversationType, targetGroup } = signature;
      this.createTournamentConversationBySignature({
        tournamentId: this.currentTournament.id,
        round: this.round,
        grid: this.grid,
        conversationType,
        targetGroup,
        captainsOnly: true,
        visible: false,
        blockId: this.blockId,
      })
        .then(conversation =>
          this.openConversationInSliderChatEditor({
            conversation,
            predefinedTitle: `${this.roundName} (${targetGroup}) `,
            predefinedSubtitle: '',
          })
        )
        .catch(this.errorNotify)
        .finally(() => {
          this.unsetLoading();
          this.sliderChatToggleLoader(false);
        });
    },
  },
};
</script>

<style lang="scss">
.group-chat-round {
  border: none;
  background-color: rgb(15, 15, 15);
  color: white;
  border-radius: 5px;
  width: 100px;
  height: 40px;
  justify-self: flex-end;
}
.btn-inside-wrap {
  display: flex;
  justify-content: space-between;
  border-color: #373737;
}
</style>
